import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import hasFeature from 'lumen/helpers/has-feature';

interface HotelRatesTablesCellsThOtbSignature {
  Args: {
    column: {
      isMarketOTBColumn: boolean;
      name: string;
      otbOutOfSyncUtil: {
        isMarketOtbOutOfSync: boolean;
        isOtbOutOfSync: boolean;
        marketOtbLastUpdatedOnString: string;
        otbLastUpdatedOnString: string;
      };
      textAlign: 'left' | 'right';
    };
  };
}

export default class HotelRatesTablesCellsThOtb extends Component<HotelRatesTablesCellsThOtbSignature> {
  get hasNoIcon(): boolean {
    return !this.myOtbOutOfSync && !this.marketOtbOutOfSync;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get marketOtbOutOfSync() {
    return (
      this.args.column.isMarketOTBColumn &&
      this.args.column.otbOutOfSyncUtil.isMarketOtbOutOfSync
    );
  }

  get myOtbOutOfSync(): boolean {
    return (
      !this.args.column.isMarketOTBColumn &&
      this.args.column.otbOutOfSyncUtil.isOtbOutOfSync
    );
  }

  <template>
    <div
      class="rates-table-header-cell text-200--bold flex gap-100
        {{if (eq @column.textAlign 'left') 'justify-start'}}
        {{if (eq @column.textAlign 'right') 'justify-end'}}"
    >
      <span
        class="{{if
            (hasFeature 'otb.empty_placeholder')
            'text-brand font-bold'
          }}
          {{if this.hasNoIcon 'pr-400'}}"
      >
        {{@column.name}}
      </span>
      <div class="rates-table-header-cell--icon flex items-center">
        {{#if this.myOtbOutOfSync}}
          {{! My OTB out of sync }}
          <GeneralIconWithTooltip
            @iconName="sync-disabled"
            @side="top"
            @size="small"
            @tooltipContent={{@column.otbOutOfSyncUtil.otbLastUpdatedOnString}}
          />
        {{else if this.marketOtbOutOfSync}}
          {{! Market OTB out of sync }}
          <GeneralIconWithTooltip
            @iconName="sync-disabled"
            @side="top"
            @size="small"
            @tooltipContent={{@column.otbOutOfSyncUtil.marketOtbLastUpdatedOnString}}
          />
        {{/if}}
      </div>
    </div>
  </template>
}
